import { Singleton } from '@core/decorators/Singleton.decorator';
import { tanstackQueryService } from '@core/services/TanstackQuery.service';
import { PERMISSIONS, FLOW_PERMISSIONS } from '@shared/constants/permissionService.constant';
import { WHO_AM_I_QUERY_KEY } from '@shared/constants/whoAmI.constant';
import { combinePermissionsToEntity } from '@shared/utils/permissionService.util';
import type { TUserResponse } from '@pages/Users/models/users.model';
import type { TWhoAmIResponse } from '@pages/Users/models/whoAmI.model';
import type { TFlowPermissions } from '@shared/models/permissionService.model';
import type { AxiosResponse } from 'axios';

@Singleton
class PermissionService {
  private get permissions() {
    return new Set(
      tanstackQueryService.queryClient.getQueryState<AxiosResponse<TWhoAmIResponse>>([
        WHO_AM_I_QUERY_KEY
      ])?.data?.data.user.permissions ?? []
    );
  }

  public getPermissionEntity(permissions = [...this.permissions]) {
    return combinePermissionsToEntity(PERMISSIONS, new Set(permissions));
  }

  public getFlowPermissionEntity(permissions: TFlowPermissions = []) {
    return combinePermissionsToEntity(FLOW_PERMISSIONS, new Set(permissions));
  }

  public get getCurrentUserInfo() {
    return tanstackQueryService.queryClient.getQueryState<AxiosResponse<TUserResponse>>([
      WHO_AM_I_QUERY_KEY
    ])?.data?.data.user;
  }
}

const permissionService = new PermissionService();

export { permissionService };
